import { useLazyQuery } from '@apollo/client';
import { IconButton, Tooltip } from '@material-ui/core';
import { Send } from '@material-ui/icons';
import React, { useState } from 'react';

import { JobStatus } from 'shared/models/job';

import { JOB_FOR_OUTREACH } from '../graphql/queries/outreach';
import { useModal } from '../hooks/use-modal';
import { JobOutreachesDialog } from './job-outreaches-dialog';

export const JobOutreachButton: React.FC<{
    jobId: string;
    iconColor?: string;
    iconSize?: 'small' | 'default';
}> = ({ jobId, iconColor, iconSize }) => {
    const [fetchJob, { loading }] = useLazyQuery<
        {
            job: {
                id: string;
                status: JobStatus;
                dailyEmailLimit: number;
                client: { id: string; name: string };
            };
        },
        { jobId: string }
    >(JOB_FOR_OUTREACH);

    const { hideLoading, setAlert, showLoading } = useModal();
    const [job, setJob] = useState<{
        id: string;
        status: JobStatus;
        dailyEmailLimit: number;
        client: { id: string; name: string };
    }>(null);

    const [dialogOpen, setDialogOpen] = useState(false);

    const handleCloseOutreach = () => {
        setDialogOpen(false);
    };

    const handleMenuButtonTap = async (event: React.SyntheticEvent<{}>) => {
        event.preventDefault();
        if (loading) return;

        try {
            showLoading();
            const result = await fetchJob({ fetchPolicy: 'cache-first', variables: { jobId } });
            if (!result.data?.job) {
                setAlert('Error', 'Job not found');
                return;
            }
            setJob(result.data.job);
            setDialogOpen(true);
        } catch (e) {
            setAlert('Error', 'Error loading job outreach');
        } finally {
            hideLoading();
        }
    };

    const dialog =
        dialogOpen && job ? (
            <JobOutreachesDialog
                jobId={jobId}
                client={job.client}
                onClose={handleCloseOutreach}
                open={dialogOpen}
                status={job.status}
                dailyEmailLimit={job.dailyEmailLimit}
            />
        ) : null;

    const buttonSize = iconSize === 'small' ? 'small' : 'medium';
    const disabled = loading;

    return (
        <div>
            <Tooltip title="Outreaches">
                <span>
                    <IconButton size={buttonSize} onClick={handleMenuButtonTap} disabled={disabled}>
                        <Send htmlColor={iconColor} fontSize={iconSize} />
                    </IconButton>
                </span>
            </Tooltip>
            {dialog}
        </div>
    );
};
